export enum BadgeTypeEnum {
  quantity = 'quantity',
  new = 'new',
}
